import BaseRepository from "@/services/resources/repository";

class Repository extends BaseRepository {
    constructor(model, schema) {
        super(model, schema);
    }

    collection() {
        return this.transformer.many(
            this.try(
                this.baseQuery().sort('publishAt', 'desc').get()
            )
        );
    }
}

export default Repository;
